export default {
  historicRoutes(state) {
    return state.historicRoutes || [];
  },
};
